import { useHistory } from "react-router-dom";
import {
  Card,
  BORDER,
  MUTED,
  TEXT,
  PictX,
  PrimaryButton,
  GhostButton,
} from "../../Pages/Sponsor/adminShared";

const DEFAULT_IMG = "/static/img/default_profile_image.png";

const HubsTable = (props) => {
  const history = useHistory();

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
        gap: 18,
      }}
    >
      {props.hubs.map((hub) => (
        <Card key={hub.id} style={{ padding: 20, display: "flex", flexDirection: "column" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 14 }}>
            <img
              src={hub.image || DEFAULT_IMG}
              alt={hub.name}
              style={{
                width: 56,
                height: 56,
                borderRadius: 16,
                objectFit: "cover",
                border: `1px solid ${BORDER}`,
                flexShrink: 0,
              }}
            />
            <div style={{ minWidth: 0 }}>
              <div
                style={{
                  fontSize: 17,
                  fontWeight: 800,
                  color: TEXT,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {hub.name}
              </div>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              gap: 8,
              fontSize: 13,
              color: MUTED,
              lineHeight: 1.6,
              marginBottom: 18,
              flex: 1,
            }}
          >
            <span style={{ flexShrink: 0, marginTop: 2 }}>
              <PictX name="pin" size={16} stroke={MUTED} strokeWidth={1.6} />
            </span>
            <span>
              〒{hub.postal_code}
              <br />
              {hub.state}
              {hub.city}
              {hub.address_line_1}
              {hub.address_line_2}
            </span>
          </div>

          <div style={{ display: "flex", gap: 10 }}>
            <PrimaryButton
              icon="ticket"
              style={{ flex: 1, padding: "10px 14px", fontSize: 13 }}
              onClick={() => history.push("/sponsor/hubs/" + hub.id + "/coupons")}
            >
              クーポン
            </PrimaryButton>
            <GhostButton
              style={{ padding: "10px 16px", fontSize: 13 }}
              onClick={() => history.push("/sponsor/hubs/" + hub.id + "/edit")}
            >
              編集
            </GhostButton>
          </div>
        </Card>
      ))}
    </div>
  );
};

export default HubsTable;
